// Autogenerated file
export const documentTagGroupsEnum = {
    General: "General",
    Cargo: "Cargo",
    Route: "Route",
    Transport: "Transport",
    Client: "Client",
    Carrier: "Carrier",
    Shipper: "Shipper",
    Finance: "Finance",
    Services: "Services",
    Documents: "Documents",
    Contacts: "Contacts",
    Bank: "Bank",
    Driver: "Driver",
    Other: "Other",
};
export const documentTagGroups = [
    { label: "Общие сведения", value: "General" },
    { label: "Груз", value: "Cargo" },
    { label: "Маршрут", value: "Route" },
    { label: "Транспорт", value: "Transport" },
    { label: "Клиент", value: "Client" },
    { label: "Перевозчик", value: "Carrier" },
    { label: "Отправитель", value: "Shipper" },
    { label: "Стоимость и налоги", value: "Finance" },
    { label: "Услуги", value: "Services" },
    { label: "Документы", value: "Documents" },
    { label: "Контакты", value: "Contacts" },
    { label: "Банковские реквизиты", value: "Bank" },
    { label: "Водитель", value: "Driver" },
    { label: "Прочее", value: "Other" },
];
